import * as React from 'react';
export const IcHotspotLocator = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4 11a8 8 0 012.05-5.33A1 1 0 006.3 5a1 1 0 00-.3-.74 1 1 0 00-1.41.07 10 10 0 000 13.34 1.002 1.002 0 001.49-1.34A8 8 0 014 11zm8 2a2 2 0 100-4 2 2 0 000 4zm-3.18.39a4 4 0 010-4.78 1.002 1.002 0 10-1.59-1.22 6 6 0 000 7.22 1.002 1.002 0 101.59-1.22zm8-6a1.002 1.002 0 00-1.59 1.22 4 4 0 010 4.78 1.002 1.002 0 101.59 1.22 6 6 0 00-.05-7.22h.05zm2.67-3.06A1.002 1.002 0 0018 5.67a8 8 0 010 10.66 1 1 0 00-.25.67 1 1 0 001.74.67 10 10 0 000-13.34zm-6.34 10.21a1.54 1.54 0 00-2.3 0l-2.5 3A1.5 1.5 0 009.5 20h5a1.519 1.519 0 001.36-.86 1.49 1.49 0 00-.21-1.6l-2.5-3z'
      fill='currentColor'
    />
  </svg>
);
